import React from 'react'
import { useState } from 'react';
import { FaAddressBook } from "react-icons/fa";
import { FaAddressCard } from "react-icons/fa";
import { FaIdCardAlt } from "react-icons/fa";
import { FaIdBadge } from "react-icons/fa";
import { PiPhoneCallFill } from "react-icons/pi";
import { FaSquarePollHorizontal } from "react-icons/fa6";




// components
import SenderIdRequest from './SenderIdRequest';
import SMSTemplateRequest from './SMSTemplateRequest'
import RCSAgentRequest from './RCSAgentRequest'
import RCSTemplateRequest from './RCSTemplateRequest'
import VoiceFileRequest from './VoiceFileRequest'
import TTSTemplateRequest from './TTSTemplateRequest'



function Approval() {

    const [activeTab, setActiveTab] = useState("SenderIdRequest");

    const tabList = [
        {
            id: "SenderIdRequest", label: "SenderId Request", icon: <FaAddressBook />
            , component: <SenderIdRequest />
        },
        {
            id: "SMSTemplateRequest", label: "SMS Template Request", icon: <FaAddressCard />
            , component: <SMSTemplateRequest/>
        },
        {
            id: "RCSAgentsRequest", label: "RCS Agents Request", icon: <FaIdCardAlt />
            , component: <RCSAgentRequest/>
        },
        {
            id: "RCSTemplateRequest", label: "RCS Template Request", icon: <FaIdBadge />
            , component: <RCSTemplateRequest/>
        },
        {
            id: "VoiceFileRequest", label: "Voice File Request", icon: <PiPhoneCallFill />
            , component: <VoiceFileRequest/>
        },
        {
            id: "TTSTemplateRequest", label: "TTS Template Request", icon: <FaSquarePollHorizontal />
            , component: <TTSTemplateRequest/>
        },
    ];

    return (
        <>
        <div className='dark:bg-[#121519] h-[100vh]'>
            <div className=' w-[100%] flex md:pt-[70px] gap-1 px-2 pt-[120px] dark:bg-[#121519]  '>
                {tabList.map((item, index) =>
                    <button
                        onClick={() => setActiveTab(item.id)}
                        className={` w-[16%] rounded-[5px]  py-2 text-[11px] font-bold flex items-center justify-center gap-1 ${activeTab === item.id ? 'bg-[#37715d] text-[#fff]' : 'bg-[#e0e0e0] text-[#333]'} `} > {item.icon}  <span className='md:block hidden'>{item.label}</span>  </button>
                )
                }
            </div>
            <div className="pt-4 px-2 dark:bg-[#121519]">
                {tabList.find((t) => t.id === activeTab)?.component}
            </div>
            </div>
        </>
    )
}

export default Approval
